import script from "./PartyBuilding.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartyBuilding.vue?vue&type=script&setup=true&lang=ts"

import "./PartyBuilding.vue?vue&type=style&index=0&id=6845854e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6845854e"]])

export default __exports__